import React from "react";
import { Modal } from "react-bootstrap";
import Button from "../../components/button";

const RemoveSportModal = ({
  isRemoveOpen,
  closeRemoveModal,
  selectedSportId,
}) => {
  return (
    <Modal show={isRemoveOpen} onHide={closeRemoveModal} centered>
      <Modal.Header closeButton>
        <Modal.Title>Remove Sport</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to remove this sport from the database?
      </Modal.Body>
      <Modal.Footer>
        <Button text="Close" callBack={closeRemoveModal} />
        <Button text="Remove" callBack={closeRemoveModal} />
      </Modal.Footer>
    </Modal>
  );
};

export default RemoveSportModal;